import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useQuotePopup } from "../context/QuotePopupContext";

const FAQS = [
  {
    q: "What is the minimum order quantity?",
    a: "Our wholesale MOQ starts at 25 kg per grade for first-time buyers. Repeat clients can avail 10 kg starter packs. Distributor and container-load contracts come with custom MOQ structuring.",
  },
  {
    q: "Do you supply directly from Kerala plantations?",
    a: "Yes. We procure 100% of our green cardamom from estate partners in Idukki, Wayanad and Vandanmedu — typically within 48 hours of harvest. Every batch is lot-traceable.",
  },
  {
    q: "How are wholesale prices structured?",
    a: "Prices are quoted per kilogram, grade-wise, and indexed to current market rates from the Spices Board India auctions. Distributors receive tiered pricing on monthly volume commitments.",
  },
  {
    q: "What is your delivery timeline in Bangalore?",
    a: "Standard B2B orders within Bangalore city limits are dispatched within 24–48 hours. Pan-Karnataka deliveries take 2–4 working days depending on location.",
  },
  {
    q: "Do you provide quality certificates?",
    a: "Every shipment is accompanied by a Certificate of Analysis (COA) covering moisture, oil content, colour grade and microbial parameters. FSSAI documentation is included.",
  },
  {
    q: "Can you supply private-label / custom packaging?",
    a: "Absolutely. We offer private-label packaging from 100 g consumer packs to 25 kg trade sacks. Minimum 250 kg per SKU for label customisation.",
  },
  {
    q: "Do you accept GST invoicing?",
    a: "Yes. We are GST-registered in Karnataka and provide tax invoices for every B2B transaction. Input credit available for registered buyers.",
  },
];

export const FAQ = () => {
  const { openPopup } = useQuotePopup();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-pad bg-white"
    >
      <div className="container-luxury">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="lg:sticky lg:top-32"
            >
              <div className="heading-eyebrow">
                <span className="line" />
                <span className="text">Buyer Questions</span>
              </div>
              <h2 className="font-serif text-3xl md:text-5xl text-[#0E4D3D] leading-tight">
                Everything wholesalers ask, answered.
              </h2>
              <p className="mt-6 text-[#4A4A4A] font-light leading-relaxed">
                Can't find your answer? Our trade desk responds within one
                business hour.
              </p>
              <button
                onClick={openPopup}
                data-testid="faq-cta"
                className="btn-emerald mt-8"
              >
                Ask The Trade Desk
              </button>
            </motion.div>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#0E4D3D]/15"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline group">
                    <span className="font-serif text-lg md:text-xl text-[#0E4D3D] group-hover:text-[#C9A227] transition-colors pr-6">
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#4A4A4A] text-base font-light leading-relaxed pb-6 pr-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
